const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilInCogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.34 94.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63.31,42.94a16.78,16.78,0,0,0-3.44-6.24L57.6,34.52a16.65,16.65,0,0,0-6.53-3.16L7.32,75.11h0L.79,91.87a1.34,1.34,0,0,0,.32,1.36,1.32,1.32,0,0,0,.93.38,1.23,1.23,0,0,0,.42-.07L19.23,87h0Z",
    style: {
      fill: "#ccebf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,14.1,73.17,9.25l-3.29,3.3.43.27,1.12.75-.38,7.49,2.33,2.12,7.47-.38.74,1.08c.11.15.21.31.31.46l3.18-3.18Z",
    style: {
      fill: "#ccebf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,18.94l4.61-4.62a5.76,5.76,0,0,0,0-8.15L88.17,2.41a5.78,5.78,0,0,0-8.16,0L75.4,7Z",
    style: {
      fill: "#ccebf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,20,74.37,7,79.5,1.9a6.49,6.49,0,0,1,9.18,0l3.76,3.76a6.49,6.49,0,0,1,0,9.18ZM76.43,7,87.31,17.91l4.1-4.1a5,5,0,0,0,0-7.13L87.65,2.93a5,5,0,0,0-7.12,0Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.72,87.22l-.42-.09a40.11,40.11,0,0,1-11.22-4.36l.73-1.26a38.51,38.51,0,0,0,10.4,4.11L44,79.19l.35,0c1,.09,1.9.13,2.75.13a31.8,31.8,0,0,0,3.36-.18l.36,0,5.74,6.36a38.38,38.38,0,0,0,11.78-5.15l-.45-8.81.26-.23a32.14,32.14,0,0,0,3.58-3.79l.23-.29,8.55.44a38.47,38.47,0,0,0,4.76-12.54l-6.64-6v-.57c0-.25,0-.51,0-.76,0-.92,0-1.86-.13-2.87l0-.36,6.42-5.79A38.55,38.55,0,0,0,79.29,26l-8.94.45-.23-.24c-.66-.7-1.35-1.37-2.05-2L67.81,24l.45-8.79A38.37,38.37,0,0,0,55.08,9.74l-5.91,6.55-.35,0c-.84,0-1.69-.06-2.53,0l-.57,0-6-6.63a38.36,38.36,0,0,0-13.1,5.13l.45,8.65-.28.23a32.74,32.74,0,0,0-2.64,2.51l-.23.24L15,25.94A38.43,38.43,0,0,0,9.43,38.27L15.79,44l0,.36a30.54,30.54,0,0,0-.19,3.42c0,.53,0,1.05,0,1.58l0,.34L9.05,55.64A38.7,38.7,0,0,0,13,66.39l-1.27.69A39.61,39.61,0,0,1,7.55,55.51l-.08-.4,6.67-6c0-.43,0-.87,0-1.3a31.6,31.6,0,0,1,.16-3.2L7.82,38.77l.1-.42A39.78,39.78,0,0,1,14,24.78l.23-.34,9.08.47c.73-.75,1.48-1.47,2.26-2.14L25.14,14l.36-.23A39.75,39.75,0,0,1,39.87,8.13l.4-.08,6.08,6.74c.73,0,1.47,0,2.2,0l6-6.66.4.08a39.91,39.91,0,0,1,14.45,5.95l.34.23-.45,8.93c.56.51,1.11,1.05,1.64,1.6L80,24.48l.23.33a39.9,39.9,0,0,1,6.19,14.05l.09.41L80,45.15c.08.92.11,1.79.11,2.64,0,.24,0,.47,0,.71l6.74,6.09-.07.39a39.82,39.82,0,0,1-5.24,13.8l-.23.37-8.67-.44a34.24,34.24,0,0,1-3.26,3.44l.46,8.95-.34.22A39.91,39.91,0,0,1,56.5,87l-.41.1-5.83-6.45c-1,.1-2.1.15-3.14.15-.79,0-1.62,0-2.51-.1Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.17,64.1V62.65a15,15,0,1,0-15-15H30.69A16.48,16.48,0,1,1,47.17,64.1Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.17,68.46a21,21,0,0,1-4.92-.59l.34-1.41a19.65,19.65,0,0,0,4.58.55A19.38,19.38,0,1,0,27.79,47.63a19.12,19.12,0,0,0,.39,3.85l-1.43.29a21.29,21.29,0,0,1-.41-4.14A20.83,20.83,0,1,1,47.17,68.46Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46,94.27A.75.75,0,0,1,2,94.06L.28,92.39a.73.73,0,0,1-.16-.78L6.64,74.84a.85.85,0,0,1,.17-.25L49.65,31.75a.72.72,0,0,1,1,1L7.94,75.51,1.64,91.7l1,1L18.83,86.4l43.1-43.11a.73.73,0,0,1,1,1L19.74,87.53a.6.6,0,0,1-.25.16L2.73,94.22A.86.86,0,0,1,2.46,94.27Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.73,
    y: 17.86,
    width: 9.89,
    height: 1.45,
    transform: "translate(9.02 58.96) rotate(-45)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 58.09,
    width: 53.5,
    height: 1.45,
    transform: "translate(-31.21 42.3) rotate(-45)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.42 24.86 81.39 23.83 84.06 21.16 73.17 10.28 70.39 13.06 69.36 12.04 73.17 8.23 86.11 21.16 82.42 24.86",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.79,91.87a1.34,1.34,0,0,0,.32,1.36,1.32,1.32,0,0,0,.93.38,1.23,1.23,0,0,0,.42-.07l5.19-2L2.81,86.69Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,94.34a2,2,0,0,1-1.93-2.7v0l2.42-6.22L9,91.8,2.73,94.22A2.23,2.23,0,0,1,2,94.34Zm-.56-2.22a.58.58,0,0,0,.14.59.6.6,0,0,0,.61.15l4.12-1.61L3.09,88Z",
    style: {
      fill: "#707070"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilInCogIcon);
export default __webpack_public_path__ + "static/media/pencil-in-cog-icon.fe210af95b575b6164f1ce324206b354.svg";
export { ForwardRef as ReactComponent };